import Axios from 'axios';
const GET_PAGOS_PARTICULARES = '/Finanzas';

const GET_PAGOS_AUTOFACT = '/Finanzas/TransaccionesAutofact';

const GET_ORDENES_AUTOMOTORAS = '/Finanzas/GetOrdenesPago';

const SET_ORDEN_AUTOMOTORA = '/Finanzas/SetOrdenesPago';

const GET_CLIENT_REPORT = '/Finanzas/GetFinanceInfo';

const SEND_CLIENT_STATUS_REPORT = '/Finanzas/SendDealerStatusReport'

const GET_CLIENT_STATUS_REPORT = '/Finanzas/getdealerstatusreport'



export default {
    getPayments(qry) {
        return Axios.post(`${GET_PAGOS_PARTICULARES}?search=${qry.search}&fecha_i=${qry.fecha_i}&fecha_f=${qry.fecha_f}`);
    },
    getAutofactPayments(qry) {
        return Axios.post(`${GET_PAGOS_AUTOFACT}?search=${qry.search}&fecha_i=${qry.fecha_i}&fecha_f=${qry.fecha_f}`);
    },
    clients: {
        getOrders(qry) {
            var search = [];
            qry.client && qry.client.cod_cliente == null ? false : search.push(`cod_cliente=${qry.client.cod_cliente}`);
            qry.order == null ? false : search.push(`id_op=${qry.order}`);
            qry.estado == "all" ? false : search.push(`estado=${qry.estado}`);
            qry.comprobante == "all" ? false : search.push(`comprobante=${qry.comprobante}`);

            return Axios.post(`${GET_ORDENES_AUTOMOTORAS}?${search.join("&")}`);
        },
        setOrderStatus(order) {
            return Axios.post(`${SET_ORDEN_AUTOMOTORA}`, order);
        }
    },
    getClientReport(id) {
        return Axios.get(`${GET_CLIENT_REPORT}/${id}`)
    },
    sendClientStatusReport() {
        return Axios.post(`${SEND_CLIENT_STATUS_REPORT}`)
    },
    getClientStatusReport(cod_cliente) {
        return Axios.get(`${GET_CLIENT_STATUS_REPORT}/${cod_cliente}`)
    }

};